import ToastFail from './ToastFail';

export default ToastFail;
